module.exports = __webpack_public_path__ + "static/media/001.e5e1a6ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/thumbs/001.jpg
// module id = 348
// module chunks = 0